import { Outlet } from "react-router-dom";

import { ApprovalsGrid } from "../components/ApprovalsGrid";

/**
 * Approvals List Page component for the main approvals navigation tab.
 * Displays milestones grouped by brand and campaign for approval tracking.
 */
export function ApprovalsListPage() {
  return (
    <section className="approvals-list-page main-page">
      <div className="main-page__content">
        <div className="main-page__header">
          <h1>Approvals Dashboard</h1>
          <p className="text-muted mb-0">
            Review and manage milestone payment approvals
          </p>
        </div>
        <div className="main-page__body">
          <ApprovalsGrid />
        </div>
      </div>
      <Outlet />
    </section>
  );
}
